// extracted by mini-css-extract-plugin
export default {"footerContainer":"ForwardMessageContainer__footerContainer___oRdeD"};